import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  viewColor: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    borderWidth: 1,
    borderColor: theme.palette.divider,
    borderStyle: "solid",
    borderRadius: 4,
    margin: theme.spacing(0, 0.5, 0, 1),
  },
}));
